import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { noop, orderBy } from 'lodash';
import moment from 'moment';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { Element } from 'react-scroll';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import ExpandIcon from '@material-ui/icons/KeyboardArrowDown';
import CollapseIcon from '@material-ui/icons/KeyboardArrowUp';

import immutableToJS from 'helpers/immutableToJS';
import { scrollTo, formatPrice } from 'helpers/utils';
import {
  Badge,
  HighlightText,
  injectIntl,
  SearchComponent,
} from 'components';
import { selectState } from 'redux/selectors';
import MonthlyInvoicesCardDetail from './MonthlyInvoicesCardDetail';

const styles = () => ({
  cardAction: { marginTop: 0 },
  cardHeader: { padding: 0 },
  monthYear: { marginRight: 25, fontSize: '1.4rem' },
  headerText: { marginRight: 20, fontSize: '1.2rem' },
});

class MonthlyInvoicesCard extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isFarmer: PropTypes.bool,
    isDistributor: PropTypes.bool,
    isRestaurant: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    expanded: PropTypes.bool,
    index: PropTypes.number.isRequired,
    info: PropTypes.shape({
    }),
    monthlyPurchases: PropTypes.arrayOf(
      PropTypes.shape({
      }),
    ),
    monthlyPurchasesRequesting: PropTypes.bool,
    monthlySales: PropTypes.arrayOf(
      PropTypes.shape({
      }),
    ),
    monthlySalesRequesting: PropTypes.bool,
    noIcon: PropTypes.bool,
    searchText: PropTypes.string,

    reportType: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired,
    getMonthlyPurchases: PropTypes.func.isRequired,
    getMonthlySales: PropTypes.func.isRequired,
    setExpanded: PropTypes.func,
  };

  static defaultProps = {
    expanded: false,
    noIcon: false,
    info: {},
    monthlyPurchases: [],
    monthlyPurchasesRequesting: false,
    monthlySales: [],
    monthlySalesRequesting: false,
    setExpanded: noop,
    searchText: '',
  };

  state = {
    searchTextInItem: '',
  };

  componentWillMount() {
    this.handleExpandChange();
  }

  onCancelSearch = () => this.setState({ searchTextInItem: '' });

  onSearchText = value => this.setState({ searchTextInItem: value });

  handleExpandChange = () => {
    const expanded = !this.props.expanded;
    const {
      getMonthlyPurchases,
      getMonthlySales,
      index,
      info,
      reportType,
      setExpanded,
    } = this.props;

    setExpanded(expanded ? index : -1, () => {
      if (!expanded) return;

      setTimeout(() => scrollTo(`invoice-${index}`), 500);
    });

    if (reportType === 'monthlyinvoicesales') {
      getMonthlySales(info.monthYear);
    } else {
      getMonthlyPurchases(info.monthYear);
    }
  };

  render() {
    const { currentUser, isDistributor, isFarmer } = this.context;
    const {
      classes,
      expanded,
      index,
      info,
      monthlyPurchases,
      monthlyPurchasesRequesting,
      monthlySales,
      monthlySalesRequesting,
      reportType,
      searchText,
      formatMessage,
      noIcon,
    } = this.props;
    const currentCompanyName = currentUser && currentUser.organizations && currentUser.organizations.length > 0 &&
      currentUser.organizations[0].account && currentUser.organizations[0].account.profile &&
      currentUser.organizations[0].account.profile.companyName;
    const { searchTextInItem } = this.state;
    const data = {
      monthlyinvoicesales: monthlySales,
      monthlyinvoicepurchase: monthlyPurchases,
    }[reportType];
    const loading = {
      monthlyinvoicesales: monthlySalesRequesting,
      monthlyinvoicepurchase: monthlyPurchasesRequesting,
    }[reportType];
    let indexItem = 0;
    const groupedData = data.map(item => ({
      companyName: isDistributor && currentCompanyName === item.profile.companyName ? 'Warehouse List' : item.profile.companyName,
      orders: item.orders,
      totalCost: parseFloat(item.totalCost).toFixed(2),
      totalPrice: parseFloat(item.totalPrice).toFixed(2),
      totalNet: parseFloat(parseFloat(item.totalPrice) - parseFloat(item.totalCost)).toFixed(2),
      isWarehouseItem: isDistributor && currentCompanyName === item.profile.companyName,
      index: indexItem++,
    }));

    const sortedGroupedData = orderBy(groupedData || [], ['isWarehouseItem', 'companyName'], ['desc', 'asc']);

    let totalOrders = 0;
    let totalPrices = 0;
    let totalCosts = 0;
    let totalNets = 0;

    sortedGroupedData.forEach((groupedItem) => {
      totalOrders += parseFloat(groupedItem.orders);
      totalCosts += parseFloat(groupedItem.totalCost);
      totalPrices += parseFloat(groupedItem.totalPrice);
      totalNets += parseFloat(groupedItem.totalNet);
    });

    const totalSellers = !!info.sellers && `${info.sellers}`;
    const totalBuyers = !!info.buyers && `${info.buyers}`;
    sortedGroupedData.push({
      companyName: `Total ${reportType === 'monthlyinvoicepurchase' ? totalSellers : totalBuyers}`,
      // orders: info.orders,
      orders: totalOrders,
      totalCost: parseFloat(totalCosts).toFixed(2),
      totalPrice: parseFloat(totalPrices).toFixed(2),
      totalNet: parseFloat(totalNets).toFixed(2),
    });

    // const badgeColor = {
    //   monthlyinvoicepurchase: 'warning',
    //   monthlyinvoicesales: 'primary',
    // }[reportType];
    // const badgeTitle = {
    //   monthlyinvoicepurchase: 'Purchases Orders',
    //   monthlyinvoicesales: 'Sales Orders',
    // }[reportType];
    const searchTextForMonth = {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'May',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec',
    }[searchText];
    const title = (
      <div style={{
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
      }}>
        <div className={classes.monthYear}>
          <HighlightText
            highlight={searchTextForMonth}
            text={moment(info.monthYear).format('MMM YYYY')}
          />
        </div>
        <div style={{ display: 'flex' }}>
          <HighlightText
            className={classes.headerText}
            highlight={searchTextForMonth}
            text={`${reportType === 'monthlyinvoicesales' ? formatMessage('Sales') : formatMessage('Purchases')}: $${formatPrice(totalPrices)}`}
          />
          {reportType === 'monthlyinvoicesales' && !isFarmer && (
            <HighlightText
              className={classes.headerText}
              highlight={searchTextForMonth}
              text={`${formatMessage('Cost')}: $${formatPrice(totalCosts)}`}
            />
          )}
          {reportType === 'monthlyinvoicesales' && !isFarmer && (
            <HighlightText
              className={classes.headerText}
              highlight={searchTextForMonth}
              text={`${formatMessage('Net')}: $${formatPrice(totalNets)}`}
            />
          )}
          {/* <Badge type={`${badgeColor} normal big-font flex`} style={{ padding: 5 }}>
            <b>{info.orders}</b>&nbsp;{formatMessage(badgeTitle)}: &nbsp;
            {`${formatMessage('Price')} $`}
            <HighlightText
              highlight={searchText}
              text={parseFloat(info.totalPrice).toFixed(2)}
            />
            &nbsp;
            {reportType === 'monthlyinvoicesales' && !!info.buyers && `(${info.buyers} ${formatMessage('Customers')})`}
            {reportType === 'monthlyinvoicepurchase' && !!info.sellers && `(${info.sellers} ${formatMessage('Vendors')})`}
          </Badge> */}
        </div>
      </div>
    );
    return (
      <Element name={`invoice-${index}`}>
        <Card>
          <CardHeader
            action={!noIcon && (
              <IconButton
                aria-expanded={expanded}
                aria-label="Show more"
                onClick={this.handleExpandChange}
              >
                {expanded ? <CollapseIcon /> : <ExpandIcon />}
              </IconButton>
            )}
            classes={{
              action: classes.cardAction,
              content: classes.cardHeader,
            }}
            title={title}
          />
          <Collapse
            in={expanded}
            timeout="auto"
            unmountOnExit
          >
            <CardContent
              className={`${loading ? 'loading' : ''} loading-enabled`}
              style={{ padding: 5 }}
            >
              <SearchComponent
                cancelSearch={this.onCancelSearch}
                placeholder={formatMessage('Items')}
                search={this.onSearchText}
                searchText={searchTextInItem}
              />
              <MonthlyInvoicesCardDetail
                info={sortedGroupedData}
                isFarmer={isFarmer}
                isDistributor={isDistributor}
                reportType={reportType}
                searchText={searchTextInItem}
              />
            </CardContent>
          </Collapse>
        </Card>
      </Element>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('orders', 'monthlyPurchases')(state, 'monthlyPurchases'),
  ...selectState('orders', 'monthlySales')(state, 'monthlySales'),
});

/* istanbul ignore next */
const mapDispatchToProps = (/* dispatch */) => ({
});

export default compose(
  setDisplayName('MonthlyInvoicesCard'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(MonthlyInvoicesCard);
